export const GoalMetLocked = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="52"
    height="52"
    viewBox="0 0 52 52"
  >
    <g
      id="Goal_Met_Badge_-_Locked"
      data-name="Goal Met Badge - Locked"
      transform="translate(1 1)"
    >
      <path
        id="Path_2103"
        data-name="Path 2103"
        d="M25,0A25,25,0,1,1,0,25,25,25,0,0,1,25,0Z"
        fill="#e6e6e6"
        stroke="#666"
        strokeLinecap="round"
        strokeWidth="2"
      />
      <path
        id="Path_2056"
        data-name="Path 2056"
        d="M31.964,28.771l-1.129,6.581a.7.7,0,0,0,1.02.742l5.91-3.108,5.91,3.108a.7.7,0,0,0,1.02-.742l-1.129-6.581,4.782-4.66a.7.7,0,0,0-.39-1.2l-6.608-.96L38.4,15.964a.7.7,0,0,0-1.261,0L34.18,21.952l-6.608.96a.7.7,0,0,0-.39,1.2Zm2.784-5.481a.7.7,0,0,0,.529-.384l2.489-5.042,2.489,5.042a.7.7,0,0,0,.529.384l5.564.809L42.32,28.023a.7.7,0,0,0-.2.622l.951,5.541L38.092,31.57a.7.7,0,0,0-.654,0l-4.976,2.617.951-5.541a.7.7,0,0,0-.2-.622L29.184,24.1Z"
        transform="translate(-12.568 -5.246)"
        fill="#666"
      />
      <path
        id="Path_2057"
        data-name="Path 2057"
        d="M30.762,69.58H29.529V63.992a.2.2,0,0,0-.2-.2h-.322a.2.2,0,0,0-.086.019,4.182,4.182,0,0,1-1.49.438.2.2,0,0,0-.185.2v.484a.2.2,0,0,0,.209.2,3.65,3.65,0,0,0,1.127-.225V69.58h-1.2a.2.2,0,0,0-.2.2v.484a.2.2,0,0,0,.2.2h3.378a.2.2,0,0,0,.2-.2v-.484A.2.2,0,0,0,30.762,69.58Z"
        transform="translate(-12.681 -30.863)"
        fill="#666"
      />
      <path
        id="Path_2058"
        data-name="Path 2058"
        d="M38.049,63.581c-1.524,0-2.549,1.38-2.549,3.435s1.024,3.436,2.549,3.436S40.6,69.071,40.6,67.016,39.573,63.581,38.049,63.581Zm0,5.977c-1.18,0-1.6-1.313-1.6-2.542s.42-2.541,1.6-2.541c.987,0,1.6.974,1.6,2.541S39.036,69.558,38.049,69.558Z"
        transform="translate(-17.099 -30.751)"
        fill="#666"
      />
      <path
        id="Path_2059"
        data-name="Path 2059"
        d="M50.057,63.581c-1.525,0-2.549,1.38-2.549,3.435s1.024,3.436,2.549,3.436,2.549-1.381,2.549-3.436S51.581,63.581,50.057,63.581Zm0,5.977c-1.18,0-1.6-1.313-1.6-2.542s.42-2.541,1.6-2.541c.987,0,1.6.974,1.6,2.541S51.044,69.558,50.057,69.558Z"
        transform="translate(-23.479 -30.751)"
        fill="#666"
      />
      <path
        id="Path_2060"
        data-name="Path 2060"
        d="M68.209,70.367c-.857,0-1.41.715-1.41,1.822s.554,1.823,1.41,1.823,1.41-.733,1.41-1.823S69.053,70.367,68.209,70.367Zm0,2.867c-.546,0-.588-.8-.588-1.045s.042-1.044.588-1.044.578.8.578,1.044S68.746,73.234,68.209,73.234Z"
        transform="translate(-33.727 -34.356)"
        fill="#666"
      />
      <path
        id="Path_2061"
        data-name="Path 2061"
        d="M65.663,63.89a.2.2,0,0,0-.173-.1h-.529a.2.2,0,0,0-.175.1l-3.468,6.273a.2.2,0,0,0,.176.3h.52a.2.2,0,0,0,.176-.1l3.477-6.272A.2.2,0,0,0,65.663,63.89Z"
        transform="translate(-30.802 -30.863)"
        fill="#666"
      />
      <path
        id="Path_2062"
        data-name="Path 2062"
        d="M61.934,65.5c0-1.091-.567-1.823-1.41-1.823s-1.41.716-1.41,1.823.554,1.822,1.41,1.822S61.934,66.589,61.934,65.5Zm-2,0c0-.245.042-1.045.588-1.045s.578.8.578,1.045-.041,1.045-.578,1.045S59.937,65.744,59.937,65.5Z"
        transform="translate(-29.644 -30.802)"
        fill="#666"
      />
    </g>
  </svg>
);

export const GoalMetUnLocked = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="52"
    height="56"
    viewBox="0 0 52 56"
  >
    <defs>
      <linearGradient
        id="linear-gradient"
        x1="0.5"
        x2="0.5"
        y2="1"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="#d11947" />
        <stop offset="1" stopColor="#8d0034" />
      </linearGradient>
    </defs>
    <g
      id="Goal_Met_Badge_-_Unlocked"
      data-name="Goal Met Badge - Unlocked"
      transform="translate(-15 1355)"
    >
      <g id="Group_2666" data-name="Group 2666" transform="translate(16 -1350)">
        <path
          id="Path_2103"
          data-name="Path 2103"
          d="M25,0A25,25,0,1,1,0,25,25,25,0,0,1,25,0Z"
          stroke="#8d0034"
          strokeLinecap="round"
          strokeWidth="2"
          fill="url(#linear-gradient)"
        />
        <g id="Group_2804" data-name="Group 2804">
          <path
            id="Path_2056"
            data-name="Path 2056"
            d="M31.964,28.771l-1.129,6.581a.7.7,0,0,0,1.02.742l5.91-3.108,5.91,3.108a.7.7,0,0,0,1.02-.742l-1.129-6.581,4.782-4.66a.7.7,0,0,0-.39-1.2l-6.608-.96L38.4,15.964a.7.7,0,0,0-1.261,0L34.18,21.952l-6.608.96a.7.7,0,0,0-.39,1.2Zm2.784-5.481a.7.7,0,0,0,.529-.384l2.489-5.042,2.489,5.042a.7.7,0,0,0,.529.384l5.564.809L42.32,28.023a.7.7,0,0,0-.2.622l.951,5.541L38.092,31.57a.7.7,0,0,0-.654,0l-4.976,2.617.951-5.541a.7.7,0,0,0-.2-.622L29.184,24.1Z"
            transform="translate(-12.568 -5.246)"
            fill="#fff"
          />
          <path
            id="Path_2057"
            data-name="Path 2057"
            d="M30.762,69.58H29.529V63.992a.2.2,0,0,0-.2-.2h-.322a.2.2,0,0,0-.086.019,4.182,4.182,0,0,1-1.49.438.2.2,0,0,0-.185.2v.484a.2.2,0,0,0,.209.2,3.65,3.65,0,0,0,1.127-.225V69.58h-1.2a.2.2,0,0,0-.2.2v.484a.2.2,0,0,0,.2.2h3.378a.2.2,0,0,0,.2-.2v-.484A.2.2,0,0,0,30.762,69.58Z"
            transform="translate(-12.682 -30.863)"
            fill="#fff"
          />
          <path
            id="Path_2058"
            data-name="Path 2058"
            d="M38.049,63.581c-1.524,0-2.549,1.38-2.549,3.435s1.024,3.436,2.549,3.436S40.6,69.071,40.6,67.016,39.573,63.581,38.049,63.581Zm0,5.977c-1.18,0-1.6-1.313-1.6-2.542s.42-2.541,1.6-2.541c.987,0,1.6.974,1.6,2.541S39.036,69.558,38.049,69.558Z"
            transform="translate(-17.1 -30.751)"
            fill="#fff"
          />
          <path
            id="Path_2059"
            data-name="Path 2059"
            d="M50.057,63.581c-1.525,0-2.549,1.38-2.549,3.435s1.024,3.436,2.549,3.436,2.549-1.381,2.549-3.436S51.581,63.581,50.057,63.581Zm0,5.977c-1.18,0-1.6-1.313-1.6-2.542s.42-2.541,1.6-2.541c.987,0,1.6.974,1.6,2.541S51.044,69.558,50.057,69.558Z"
            transform="translate(-23.479 -30.751)"
            fill="#fff"
          />
          <path
            id="Path_2060"
            data-name="Path 2060"
            d="M68.209,70.367c-.857,0-1.41.715-1.41,1.822s.554,1.823,1.41,1.823,1.41-.733,1.41-1.823S69.053,70.367,68.209,70.367Zm0,2.867c-.546,0-.588-.8-.588-1.045s.042-1.044.588-1.044.578.8.578,1.044S68.746,73.234,68.209,73.234Z"
            transform="translate(-33.727 -34.356)"
            fill="#fff"
          />
          <path
            id="Path_2061"
            data-name="Path 2061"
            d="M65.663,63.89a.2.2,0,0,0-.173-.1h-.529a.2.2,0,0,0-.175.1l-3.468,6.273a.2.2,0,0,0,.176.3h.52a.2.2,0,0,0,.176-.1l3.477-6.272A.2.2,0,0,0,65.663,63.89Z"
            transform="translate(-30.801 -30.863)"
            fill="#fff"
          />
          <path
            id="Path_2062"
            data-name="Path 2062"
            d="M61.934,65.5c0-1.091-.567-1.823-1.41-1.823s-1.41.716-1.41,1.823.554,1.822,1.41,1.822S61.934,66.589,61.934,65.5Zm-2,0c0-.245.042-1.045.588-1.045s.578.8.578,1.045-.041,1.045-.578,1.045S59.937,65.744,59.937,65.5Z"
            transform="translate(-29.645 -30.802)"
            fill="#fff"
          />
        </g>
      </g>
      <g id="Group_2805" data-name="Group 2805" transform="translate(49 -1355)">
        <circle
          id="Ellipse_55"
          data-name="Ellipse 55"
          cx="8.5"
          cy="8.5"
          r="8.5"
          fill="#008a1c"
        />
        <g
          id="Check_Mark_-_S"
          data-name="Check Mark - S"
          transform="translate(4 5.29)"
        >
          <path
            id="Check_Mark_-_S-2"
            data-name="Check Mark - S"
            d="M9.381,2.22a.442.442,0,0,0-.639,0L3.572,7.414,1.262,5.136a.442.442,0,0,0-.631,0,.459.459,0,0,0,0,.639l2.63,2.6a.483.483,0,0,0,.32.131.459.459,0,0,0,.32-.139l5.481-5.53A.451.451,0,0,0,9.381,2.22Z"
            transform="translate(-0.502 -2.083)"
            fill="#fff"
          />
        </g>
      </g>
    </g>
  </svg>
);
